
import { css } from 'lit';
export default css`
:host {
  display: block;
}

.cta-image__wrapper--full-width {
  position: relative;
  width: 100vw;
  max-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
  align-items: center !important;
  justify-content: center !important;
  overflow: hidden;
  margin-top: -23px;
}

.cta-image__wrapper--full-width div[slot="image"] {
    width: 100%;
  }

.cta-image__wrapper--full-width {

  display: flex;
  flex-direction: column;
}

@media (min-width: 1024px) {

.cta-image__wrapper--full-width {
    margin-top: -134px
}
  }

.cta-image__image {
  width: 100%;
  max-height: 600px;
  position: relative;
}

@media print {

.cta-image__image {
    position: absolute;
    z-index: -10;
    align-items: center;
    margin-left: 14rem;
    width: 68vw;
    max-height: 450px;
    height: 350px
}
  }

@media (min-width: 1024px) {

.cta-image__image:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    z-index: 1;
    background: linear-gradient(103deg, #6A2099 5.18%, rgba(106, 32, 153, 0.00) 69.01%)
}
  }

.cta-image__alert-text {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));

  position: absolute;
  display: inline;
  top: 0;
  right: 0;
  width: auto;
  color: white;
  font-family: lato;
  font-weight: bold;
  font-size: 20px;
  line-height: 36px;
  padding: 9px 16px;
  z-index: 2;
}

@media (min-width: 1200px) {

.cta-image__alert-text {
    font-size: 24px;
  }
  }

.cta-image__content {
  position: relative;
  margin:0 auto;
  margin-top: -100px;
  width: calc(100% - 30px);
  padding: 40px 20px;
  font-size: 55px;
  background-color: white;
  color: black;
  max-width: 640px;
  z-index: 2;
}

@media (min-width: 1024px) {

.cta-image__content {
    width: calc(100% - 175px);
    max-width: 1250px;
    margin-top: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 75px;
    background-color: transparent;
    color: white
}
  }

@media (min-width: 1366px) {

.cta-image__content {
    width: 100%
}
  }

@media print {

.cta-image__content {
    left: -1.5rem;
    padding-left: 1.5rem;
    max-width: 464px;
    padding-top: 42px;
    padding-bottom: 44px;
    margin: 0
}
  }

.cta-image__content .heading {
  margin-bottom: 0px;
}

.cta-image__content .heading {
  font-family: adobe-caslon-pro, Adobe Caslon Pro, EB Garamond, serif;
}

.cta-image__content .heading {
  font-weight: 700;
}

.cta-image__content .heading {
  line-height: 1.1;
}

.cta-image__content .heading {
    max-width: 640px;
  }

@media (min-width: 1024px) {

.cta-image__content .heading {
      font-size: 70px !important
  }
    }

.cta-image__content .heading i {
      display: block;
    }

.cta-image__content .style--cta-image {
  font-size: 2.5rem;
}

.cta-image__content .style--cta-image {
  letter-spacing: -0.0625rem;
}

@media (min-width: 1024px) {

  .cta-image__content .style--cta-image {
    font-size: 2.8125rem;
  }
}

@media (min-width: 1024px) {

  .cta-image__content .style--cta-image {
    letter-spacing: -0.0425rem;
  }
}
`;